import { ThemeContext } from '../configure/ConfigureThemeProvider';
import { useContext } from 'react';
import ThemeAPIMapper from './ThemeAPIMapper';

export const useTheme: () => ThemeAPIMapper = () => {
  const theme = useContext(ThemeContext);
  return theme as ThemeAPIMapper;
};
